import { v4 as uuidV4 } from 'uuid';

import { genderResponseMap } from '@verantos-dev/shared-constants';
import { CohortSubjectDetail } from '@verantos-dev/types-cohorts';

export const transformGenderResponseDataForDisplay = (genderResponseString: string) => {
  const genderFromMap = genderResponseMap[genderResponseString.toLowerCase()];
  return genderFromMap ? genderFromMap : '--';
};

export const transformCohortSummaryDetailForDisplay = (
  data: CohortSubjectDetail[] | undefined
): CohortSubjectDetail[] => {
  return (
    data?.map((subject) => {
      return {
        ...subject,
        subjectId: subject?.subjectId || uuidV4(),
        gender: transformGenderResponseDataForDisplay(subject?.gender || ''),
      };
    }) ?? []
  );
};
